"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagesDataProvider = function () {
  function ImagesDataProvider(Images) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ImagesDataProvider);
    this.ImagesService = Images;
  }

  (0, _createClass3.default)(ImagesDataProvider, [{
    key: "getCategory",
    value: function getCategory(data) {
      return this.ImagesService.loadCategories(data).then(function (categories) {
        return categories;
      });
    }
  }, {
    key: "saveCategory",
    value: function saveCategory(data) {
      return this.ImagesService.saveCategory(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "removeCategory",
    value: function removeCategory(id) {
      return this.ImagesService.removeCategory(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "getCategoryById",
    value: function getCategoryById(id) {
      return this.ImagesService.categoryById(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "updateCategory",
    value: function updateCategory(data) {
      return this.ImagesService.updateCategory(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "getImages",
    value: function getImages(data) {
      return this.ImagesService.getImages(data).then(function (result) {
        return result;
      });
    }
  }, {
    key: "getImage",
    value: function getImage(id) {
      return this.ImagesService.getImage(id).then(function (result) {
        return result;
      });
    }
  }, {
    key: "loadCategoriesNoLimit",
    value: function loadCategoriesNoLimit() {
      return this.ImagesService.loadCategoriesNoLimit().then(function (categories) {
        return categories;
      });
    }
  }, {
    key: "removeImage",
    value: function removeImage(id) {
      return this.ImagesService.removeImage(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "updateData",
    value: function updateData(data) {
      return this.ImagesService.updateData(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "updateImageOrder",
    value: function updateImageOrder(data) {
      return this.ImagesService.updateImageOrder(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "updateImageData",
    value: function updateImageData(data) {
      return this.ImagesService.updateImageData(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "checkRecordExist",
    value: function checkRecordExist(data) {
      return this.ImagesService.checkRecordExist(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "saveImageData",
    value: function saveImageData(data) {
      return this.ImagesService.saveImageData(data).then(function (resp) {
        return resp;
      });
    }
  }]);
  return ImagesDataProvider;
}();

// WEBPACK FOOTER //


exports.default = ImagesDataProvider;


/** WEBPACK FOOTER **
 ** ./client/app/modules/images/services/images.dataprovider.service.js
 **/